export const dividerArr = (arr: any[], parts: number) => {
  const sizeFragment = Math.ceil(arr.length / parts)
  const result = []
  for (let i = 0; i < parts; i++) {
    result.push(arr.slice(i * sizeFragment, (i + 1) * sizeFragment))
  }
  return result
}
